export default __webpack_public_path__ + "static/media/hero-3.d964a429.svg";